import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["countdown"];
import React, { useCallback, useEffect, useState } from 'react';
/**
 * ХОК, который добавляет обратный отсчет (например, для повторной отправки СМС)
 */
export function withCountdown() {
  return function (WrappedComponent) {
    var Component = function Component(_ref) {
      var _ref$countdown = _ref.countdown,
        countdown = _ref$countdown === void 0 ? 60 : _ref$countdown,
        props = _objectWithoutProperties(_ref, _excluded);
      var _useState = useState(countdown),
        _useState2 = _slicedToArray(_useState, 2),
        _countdown = _useState2[0],
        setCountdown = _useState2[1];
      useEffect(function () {
        var interval = setInterval(function () {
          setCountdown(function (prev) {
            return Math.max(prev - 1, 0);
          });
        }, 1000);
        return function () {
          return clearInterval(interval);
        };
      }, []);
      var reset = useCallback(function () {
        setCountdown(countdown);
      }, []);
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        countdown: {
          reset: reset,
          value: _countdown
        },
        "data-t-id": "SMSConfirmationPopup-withCountdown"
      }));
    };
    return Component;
  };
}